// Parses the `frontendCustomFields` from pipeline.json
// Resolves value from string or uses a default one
const getFrontendCustomField = ({ 
  pipelineConfig, 
  fieldName,
}) => {
  const field = pipelineConfig?.frontendCustomFields?.[fieldName]

  if (!field) return field

  const parseValue = (value) => {
    // Return value as is if not set to not modify it
    if (value === null || value === undefined) return value
  
    // Return boolean if explicitly set
    if (typeof value === 'boolean') return value
    
    // Return number if explicitly set
    if (typeof value === 'number') return value
  
    const rawValue = String(value).trim().toLowerCase();
  
    // Check if value is a boolean in a string format
    if (rawValue === "true") return true;
    if (rawValue === "false") return false;
  
    // Check if value is an integer in a string format
    if (/^\d+$/.test(rawValue)) return parseInt(rawValue);
  
    return rawValue;
  };

  // Get parsed value from config
  const parsedValue = parseValue(field.value)
  const parsedDefault = parseValue(field.default)

  // Fallback to default value, but if 'false' or zero weren't set explicitly 
  if (!parsedValue && parsedValue !== false && parsedValue !== 0) return parsedDefault

  return parsedValue
}

export {
  getFrontendCustomField,
}
